<ng-container *ngrxLet="conversation$ as conversation">
  <div
    *ngIf="(minimized$ | async) === false"
    class="conv-dialog-wrapper"
    tabindex="0"
  >
    <div class="conv-dialog-container" data-omni-qa="conv-dialog">
      <cigna-omni-messaging-list
        id="printSection"
        (messageViewed)="setMessageViewed($event)"
        (sendCta)="postCta($event)"
        (navigateBack)="navigateBack()"
        [conversationType]="conversationType$ | async"
        [disclaimer]="disclaimer$ | async"
        [messages]="events$ | async"
        [outroObj]="outroObj$ | async"
        [conversation]="conversation"
        [isLiveChatAvailable]="liveChatAvailable$ | async"
        [chatCloseHrsMsg]="chatCloseHrsMsg$ | async"
        [isUnmuted]="isUnmuted$ | async"
        [chatTitle]="title$ | async"
        [isHistoryView]="isHistoryView$ | async"
        [isAiBot]="isAiBot$ | async"
        [shouldEnableNewChat]="shouldEnableChat$ | async"
        [shouldEnablePreChatWelcome]="shouldEnablePreChatWelcome$ | async"
        [isUseRightNowChat]="useRightNowChat$ | async"
        [shouldEnabledBackToPrevious]="shouldEnabledBackToPrevious$ | async"
        [canReplaceBackToPreviousWithEndChat]="
          replaceBackToPreviousWithEndChat$ | async
        "
        [isUpdatingConversation]="isUpdatingConversation$ | async"
      ></cigna-omni-messaging-list>

      <cigna-omni-messaging-input
        *ngIf="inputEnabled$ | async"
        [isAiBot]="isAiBot$ | async"
        [shouldEnablePreChatWelcome]="shouldEnablePreChatWelcome$ | async"
        [conversation]="conversation"
        [isUpdatingConversation]="isUpdatingConversation$ | async"
        (sendMessage)="postMessage($event, conversation)"
        (sendCta)="postCta($event)"
        (keyUp)="keyHandler()"
      ></cigna-omni-messaging-input>
    </div>
  </div>
  <cigna-omni-splash-close-screen
    [screenText]="screenText"
    [conversationId]="conversation?._id"
    *ngIf="closeSplashScreen$ | async"
  ></cigna-omni-splash-close-screen>
</ng-container>
